import React,{Component} from 'react';

import {
  Row,
  Col,
  Input,
  Label,
  FormGroup,
  FormText,
  Button,
  Badge
} from 'reactstrap';

import Select from 'react-select';


import Form from '../Form';
import HiddenInput from '../HiddenInput';

import without from 'lodash/without';

import CloseSVG from '../../../shared/assets/close.svg';
import InformationSVG from '../../assets/information.svg';

import './TagListInput.css';

class TagListInput extends Component {
  constructor(){
    super();

    this.state = {
      value:[],
      activeTag:null
    };
  }

  componentDidMount(){
    if(this.props.defaultValue){
      this.setState({value:this.props.defaultValue});
    }

    if(this.props.tags.length > 0){
      this.setState({activeTag:this.props.tags[0].id});
    }
  }

  handleTagSubmit(data){
    const newValue = this.state.value.concat([data.newTagId]);

    this.setState({value:newValue});
    
    if(this.props.onChange){
      this.props.onChange(newValue);
    }
  }

  handleAddActiveTag(){
    const newValue = this.state.value.concat([this.state.activeTag]),
      tagAtTop = this.props.tags.filter((t) => newValue.indexOf(t.id) < 0)[0];

    this.setState({value:newValue});
    
    if(tagAtTop){
      this.setState({activeTag:tagAtTop.id});
    }

    if(this.props.onChange){
      this.props.onChange(newValue);
    }    
  }

  handleTagRemoveClick(tag){
    const newValue = this.state.value.filter((t) => t !== tag.id);

    this.setState({value:newValue});  
    
    if(this.props.onChange){
      this.props.onChange(newValue);
    }  
  }

  render(){
    //TODO: Dont nest forms

    const selectedTags = this.props.tags.filter((t) => this.state.value.indexOf(t.id) >= 0),
      unselectedTags = this.props.tags.filter((t) => this.state.value.indexOf(t.id) < 0);

    return (
      <div className='TagListInput'>
        {selectedTags.map((tag,index) => (
          <HiddenInput 
            key={tag.id} 
            name={`${this.props.name}[${index}]`} 
            value={tag.id} 
          />
        ))}
        {unselectedTags.length > 0 && (
         <Row>
            <Col xs='10'>
              <FormGroup>
                <Input 
                  type='select' 
                  name='newTagId'
                  value={this.state.activeTag}
                  onChange={(e) => this.setState({activeTag:e.target.value})}
                >
                  {unselectedTags.map((tag) => (
                    <option key={tag.id} value={tag.id}>{tag.name}</option>
                  ))}
                </Input>
                {this.props.warning.length > 0 && (
                  <FormText className='DangerFeedback'>{this.props.warning}</FormText>
                )}
              </FormGroup>
            </Col>
            <Col xs='2'>
              <Button 
                size='sm' 
                color='primary'
                onClick={() => this.handleAddActiveTag()}
              >
                &nbsp;&nbsp;Add&nbsp;&nbsp;
              </Button>
            </Col>
          </Row>
        )}
        <Row>
          <Col xs='12'>
            {selectedTags.map((tag) => (
              <div className='SelectedTag' key={tag.id}>
                {tag.name}
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                <img
                  src={CloseSVG}
                  alt='Close'
                  style={{
                    position:'absolute',
                    right:'0.8rem',
                    top:'1rem',
                    height:12,
                    cursor:'pointer'
                  }}
                  onClick={() => this.handleTagRemoveClick(tag)}
                />
              </div>
            ))}
          </Col>
        </Row>
      </div>
    )
  }
}

TagListInput.defaultProps = {
  warning:''
};

export default TagListInput;


// WEBPACK FOOTER //
// ./src/shared/components/TagListInput/index.js